import { DropDownList } from "@progress/kendo-react-dropdowns"
import { Checkbox, CheckboxChangeEvent } from "@progress/kendo-react-inputs"
import { useLocalization } from "@progress/kendo-react-intl";
import { useState } from "react";


export const SecondSequence = () => {

    const localizationService = useLocalization();

    const [checkedSecondSequence, setCheckedSecondSequence] = useState<boolean | null | undefined>(false);

    const [secondRedValue, setSecondRedValue] = useState<any>([]);
    const [secondGreenValue, setSecondGreenValue] = useState<any>([]);
    const [secondBlueValue, setSecondBlueValue] = useState<any>([]);
    const [secondBuzzerValue, setSecondBuzzerValue] = useState<any>([]);
    const [secondVibrationValue, setSecondVibrationValue] = useState<any>([]);
    const [durationValueSelected, setDurationValueSelected] = useState<any>([]);

    var redValues:any, greenValues:any, blueValues:any, buzzzerValue:any, vibrationValue:any = [];

    redValues = greenValues = blueValues = buzzzerValue = vibrationValue = {
        "data": [
            {
                "id": 0,
                "name": 'ON'
            },
            {
                "id": 1,
                "name": 'OFF'
            },
            {
                "id": 2,
                "name": 'LF'
            },
            {
                "id": 3,
                "name": 'HF'
            }
        ]
    }

    const durationValue = {
        "data": [
            {
                "id": 0,
                "name": '1s'
            },
            {
                "id": 1,
                "name": '0'
            },
            {
                "id": 2,
                "name": '500ms'
            },
            {
                "id": 3,
                "name": '2s'
            }
        ]
    }

    const handleSecondSequence = (event: CheckboxChangeEvent) => {
        setCheckedSecondSequence(event.value);
    };

    const onSecondRedValueChange = (event: any) => {
        setSecondRedValue(event.value)
    }

    const onSecondGreenValueChange = (event: any) => {
        setSecondGreenValue(event.value)
    }

    const onSecondBlueValueChange = (event: any) => {
        setSecondBlueValue(event.value)
    }

    const onSecondBuzzerValueChange = (event: any) => {
        setSecondBuzzerValue(event.value)
    }

    const onSecondVibrationValueChange = (event: any) => {
        setSecondVibrationValue(event.value)
    }

    const onSecondDurationValueChange = (event: any) => {
        setDurationValueSelected(event.value)
    }
    
    return (

        <div style={{ display: 'inline-flex', width: '100%' }}>

            <div style={{ color: '#1A8995', textAlign: 'left', margin: '25px 0px 0px 0px' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}</div>
            <Checkbox
                //label={localizationService.toLanguageString('configuration.rules.subscription_backchannel_enabled', 'NOT_FOUND')}
                checked={checkedSecondSequence}
                style={{ marginTop: '30px', marginRight: '20px', marginLeft: '10px' }}
                onChange={handleSecondSequence}
            />

            <div style={{ display: 'inline', marginRight: '10px', marginLeft: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'red' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_red', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onSecondRedValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'green' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_green', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onSecondGreenValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left', color: 'blue' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_blue', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onSecondBlueValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_buzzer', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onSecondBuzzerValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '105px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_vibration', 'NOT_FOUND')}</div>
                <DropDownList
                    data={redValues.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onSecondVibrationValueChange}
                />
            </div>
            <div style={{ display: 'inline', marginRight: '10px', width: '120px' }}>
                <div style={{ textAlign: 'left' }}>{localizationService.toLanguageString('configuration.rules.subscription_backchannel_duration', 'NOT_FOUND')}</div>
                <DropDownList
                    data={durationValue.data?.map((value: any) => {
                        return (
                            value.name
                        )
                    })}
                    onChange={onSecondDurationValueChange}
                />
            </div>

        </div>
    )
}